module.exports = __webpack_public_path__ + "img/collectible-card-total-background-large.1dfdf7f7.svg";